import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { FloatingWhatsApp } from './FloatingWhatsApp'
import { Toaster } from '@/components/ui/toaster'

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col font-body text-foreground bg-background">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster />
    </div>
  )
}
